import { gql } from '@apollo/client'

export const CHANGE_MESSAGE_TEMPLATE = gql`
  mutation CHANGE_MESSAGE_TEMPLATE($input: MessageTemplateInput) {
    changeMessageTemplate(input: $input) {
      template_id
      name
      message {
        context_text
        mail_template
      }
    }
  }
`

export const REMOVE_MESSAGE_TEMPLATE = gql`
  mutation REMOVE_MESSAGE_TEMPLATE($template_id: Int!) {
    removeMessageTemplate(template_id: $template_id) {
      template_id
      name
      message {
        context_text
        mail_template
      }
    }
  }
`
